import React, { FC, ReactNode } from 'react';
import { DesktopPageLayoutSkeleton, MobilePageLayoutSkeleton } from '@whitesharx/starfall-frontend-core';

type Props = {
  rightContainer: ReactNode;
};

export const PageLayoutSkeleton: FC<Props> = ({ rightContainer, children }) => {
  return (
    <>
      <DesktopPageLayoutSkeleton rightContainer={rightContainer}>{children}</DesktopPageLayoutSkeleton>

      <MobilePageLayoutSkeleton>{children}</MobilePageLayoutSkeleton>
    </>
  );
};
